import React from 'react'
import ReactDOM from 'react-dom'
import TagManager from 'react-gtm-module'
import { AppProvider } from './context/AppContext'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import '../src/styles/main.scss'

// pages & routes
import { Home, Contact, Cookie, Imprint, Privacy, Services, ServicesAdvancedCustomization, ServicesCustomDevelopment, ServicesTweaksAndChanges, ServicesConvertingHeroImages, ServicesConvertingCollectionBanners, ServicesEmailHeaderDesign, ServicesNewsletterPopupsDesign, ServicesConvertingNewsletterDesign, ServicesCustomIconDesign, ServicesBannerAdsThatConvert, ServicesSocialMediaAdsThatConvert, ServicesSocialMediaCoverPhotos, Tools, Quote, Error } from './pages'

const tagManagerArgs = {
  gtmId: 'GTM-5VX865H'
}

TagManager.initialize(tagManagerArgs)

ReactDOM.render(
  <React.StrictMode>
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shopify-services" element={<Services />} />
          <Route path="/shopify-services/shopify-advanced-customization" element={<ServicesAdvancedCustomization />} />
          <Route path="/shopify-services/shopify-custom-development" element={<ServicesCustomDevelopment />} />
          <Route path="/shopify-services/shopify-theme-tweaks-changes" element={<ServicesTweaksAndChanges />} />
          <Route path="/shopify-services/converting-hero-images" element={<ServicesConvertingHeroImages />} />
          <Route path="/shopify-services/converting-collection-banners" element={<ServicesConvertingCollectionBanners />} />
          <Route path="/shopify-services/newsletter-popups-design" element={<ServicesNewsletterPopupsDesign />} />
          <Route path="/shopify-services/email-header-design" element={<ServicesEmailHeaderDesign />} />
          <Route path="/shopify-services/converting-newsletter-design" element={<ServicesConvertingNewsletterDesign />} />
          <Route path="/shopify-services/custom-icon-design" element={<ServicesCustomIconDesign />} />
          <Route path="/shopify-services/banner-ads-that-convert" element={<ServicesBannerAdsThatConvert />} />
          <Route path="/shopify-services/social-media-ads-that-convert" element={<ServicesSocialMediaAdsThatConvert />} />
          <Route path="/shopify-services/social-media-cover-photos" element={<ServicesSocialMediaCoverPhotos />} />
          <Route path="/tools" element={<Tools />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/get-a-free-quote" element={<Quote />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/cookie-policy" element={<Cookie />} />
          <Route path="/imprint" element={<Imprint />} />
          <Route path="*" element={<Error />} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  </React.StrictMode>,
  document.querySelector('#app')
)
